import { locations } from "./locations";

export type KcnStat = {
  key: "markets" | "volume" | "transactions" | "years";
  /** Static display value, e.g. "$1B+" */
  value: string;
  label: string;
  /** Count-up animation config */
  target: number;
  prefix?: string;
  suffix?: string;
};

/** Reporting year for the production figures. */
export const STATS_YEAR = 2025;

/**
 * Total KCN markets nationwide. This is the single source of truth for the
 * market count in copy, meta, and schema. It is derived from the
 * locations list, so adding or removing a market updates every number.
 */
export const MARKETS_COUNT = locations.length;

const marketsCount = MARKETS_COUNT;

/**
 * Single source of truth for KCN production metrics.
 * Never retype these numbers into a page - import from here.
 */
export const KCN_STATS: KcnStat[] = [
  {
    key: "markets",
    value: `${marketsCount}+`,
    label: "Markets nationwide",
    target: marketsCount,
    suffix: "+",
  },
  {
    key: "volume",
    value: "$1B+",
    label: `Volume closed in ${STATS_YEAR}`,
    target: 1,
    prefix: "$",
    suffix: "B+",
  },
  {
    key: "transactions",
    value: "3K+",
    label: `Transactions in ${STATS_YEAR}`,
    target: 3,
    suffix: "K+",
  },
  {
    key: "years",
    value: "40+",
    label: "Years leading the industry",
    target: 40,
    suffix: "+",
  },
];

/** Derived strings for prose, meta descriptions, and schema. */
export const STATS_TEXT = {
  year: String(STATS_YEAR),
  markets: `${marketsCount}+`,
  marketsPhrase: `${marketsCount}+ markets nationwide`,
  volume: "$1B+",
  volumeLong: "more than $1 billion",
  transactions: "3,000+",
  transactionsShort: "3K+",
  years: "40+",
  yearsPhrase: "40+ years",
  /** e.g. "$1B+ in 2025 volume across 3,000+ transactions" */
  production: `$1B+ in ${STATS_YEAR} volume across 3,000+ transactions`,
};
